import { useCallback } from "react";
import { CourtGridTimeSlot } from "../../../models/CourtGridData";
import { SlotStatus } from "../../shared/TimeSlot";

interface UseWeeklySlotStatusProps {
  exercisesInBasket: number[];
}

export default function useWeeklySlotStatus({ exercisesInBasket }: UseWeeklySlotStatusProps) {
  // Sprawdza czy slot minął na podstawie jego daty i godziny
  const isSlotPast = useCallback((slotDate: string, timeString: string) => {
    const now = new Date();
    const [hours, minutes] = timeString.split(":").map(Number);

    const slotDateTime = new Date(slotDate);
    slotDateTime.setHours(hours, minutes, 0, 0);

    return slotDateTime.getTime() <= now.getTime();
  }, []);

  const getSlotStatus = useCallback(
    (timeSlot: CourtGridTimeSlot, slotDate: string): SlotStatus => {
      // Spójnie z CourtGrid: okno internetSaleFrom/To nie zmienia wyglądu kafelka;
      // przed/po sprzedaży komunikat jest w modalu rezerwacji po kliknięciu.
      if (isSlotPast(slotDate, timeSlot.startTime)) {
        return "unavailable";
      }

      if (timeSlot.userAssigned) {
        return "assigned";
      }

      if (exercisesInBasket.includes(timeSlot.exerciseId)) {
        return "in-basket";
      }

      if (timeSlot.reserved >= timeSlot.capacity) {
        return "sold-out";
      }

      return "available";
      // prettier-ignore
    },
    [exercisesInBasket, isSlotPast]
  );

  return {
    getSlotStatus,
    isSlotPast,
  };
}
